export class AppConfig {

    static get URL_BASE() {
        return process.env.VUE_APP_SOLCONCER_SERVER;
    }

    static get S3_URL() {
        return process.env.VUE_APP_S3_URL;
    }

    static get URL_BASE_API() {
        return `${AppConfig.URL_BASE}/api/v1`;
    }

    static get TOKEN_CLAVE(){
        return "token";
    }
}
